const DESTINATION_TIME_ZONE = 'Europe/Helsinki'

export const toDestinationDate = (date: Date | string): Date => {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: DESTINATION_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date(date))

  const getPart = (type: 'year' | 'month' | 'day') => Number(parts.find(part => part.type === type)?.value)

  return new Date(getPart('year'), getPart('month') - 1, getPart('day'))
}
